module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"empty":{"title":"図面がまだ登録されていません","description":"現場の図面をアップロードして、センサー配置を管理しましょう","upload_button":"図面をアップロード"}},"en":{"empty":{"title":"No floor plans registered yet","description":"Upload a floor plan to manage sensor placement","upload_button":"Upload floor plan"}}}')
  delete Component.options._Ctor
}
